import { ROUTES as e } from "./routes.mjs";
import { PublicRoute as t } from "./PublicRoute.mjs";
import "react";
import { Redirect as n } from "react-router-dom";
import { useAuth as r } from "@maat/store-auth";
import { Fragment as i, jsx as a } from "react/jsx-runtime";
//#region src/GuestRoute.tsx
var o = ({ children: o, ...s }) => {
	let { activeProfile: c } = r();
	return /* @__PURE__ */ a(t, {
		...s,
		render: ({ location: t }) => c === "host" ? /* @__PURE__ */ a(n, { to: {
			pathname: e.HOME,
			state: { from: t }
		} }) : /* @__PURE__ */ a(i, { children: o })
	});
};
//#endregion
export { o as GuestRoute };
